import { type FC } from 'react';

interface BookingHistorySkeletonListProps {
  count?: number;
}

const BookingHistorySkeletonItem: FC = () => {
  return (
    <div className="border-border-inactive rounded-lg border py-3">
      <div className="flex flex-col gap-2 px-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex min-w-0 items-center gap-2">
            <div className="bg-divider size-6 shrink-0 animate-pulse rounded-sm" />
            <div className="bg-divider h-5 w-48 max-w-full animate-pulse rounded" />
          </div>

          <div className="bg-divider h-7 w-20 shrink-0 animate-pulse rounded" />
        </div>

        <div className="flex min-w-0 items-center gap-2">
          <div className="bg-divider size-4 shrink-0 animate-pulse rounded" />
          <div className="bg-divider h-4 w-40 max-w-full animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
};

const BookingHistorySkeletonList: FC<BookingHistorySkeletonListProps> = ({
  count = 3,
}) => {
  return (
    <div className="flex flex-col gap-2" aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <BookingHistorySkeletonItem key={index} />
      ))}
    </div>
  );
};

export default BookingHistorySkeletonList;
